import styled from 'styled-components';
import tw from 'twin.macro';

import SEO from '@app/components/seo';
import Layout from '@app/layouts/page-default';
import ContentBlock from '@app/components/content-block';

const TermsAndConditionsStyled = styled.div`
  ${tw`mt-24 lg:pt-10 px-8 mx-auto`}
  max-width: 1360px;
`;

export default function TermsAndConditions(): JSX.Element {
  return (
    <Layout>
      <SEO title="Terms and Conditions" />
      <TermsAndConditionsStyled>
        <ContentBlock>
          <h1>Terms and Conditions</h1>
          <h2>Website</h2>
          <p>
            <a href="https://kccmultiplex.lk">www.kccmultiplex.lk</a> is owned and operated by
            Property Finance &amp; Investments Kandy Private Limited, a company registered in Sri
            Lanka (referred to as "Kandy City Centre”, “KCC”, “KCC Multiplex”,
            “www.kccmultiplex.lk”, "we," "us," or "our" herein).{' '}
          </p>
          <p>
            By using this site or by clicking a box that states that you accept or agree to these
            terms, you signify your agreement to these terms of use. You acknowledge that these
            terms of use are supported by reasonable and valuable consideration, the receipt and
            adequacy of which are hereby acknowledged. Without limiting the generality of the
            foregoing, you acknowledge that such consideration includes your use of this site and
            receipt of data, materials and information available at or through this site, the
            possibility of our use or display of your submissions and the possibility of the
            publicity and promotion from our use or display of your submissions.{' '}
          </p>
          <ul>
            <li>
              The site is only for your personal use. You may not use the site for commercial
              purposes or in any way that is unlawful, or harms us or any other person or entity, as
              determined in our sole discretion.
            </li>
            <li>
              Registering with and/or the use of the www.kccmultiplex.lk services and products,
              including and without limitation the www.kccmultiplex.lk website, purchase of movie
              tickets, and other similar products or services offered by www.kccmultiplex.lk, is
              indicative that you have read and understood the terms and conditions set forth below
              and agree to be legally bound by the said terms and conditions.{' '}
            </li>
            <li>
              We reserve the right to change these terms of use from time to time by posting the new
              version on the website. It is your responsibility to check regularly this page for the
              latest terms and conditions.{' '}
            </li>
            <li>
              The service provided by www.kccmultiplex.lk is for personal &amp; non-commercial use.
              You hereby agree that you will not duplicate, download, publish, modify, distribute
              and/or use any material included in www.kccmultiplex.lk for any purpose, unless and
              otherwise you have obtained prior written permission from www.kccmultiplex.lk.{' '}
            </li>
            <li>
              You also agree that you will not use the services provided by www.kccmultiplex.lk for
              any purpose other than to subscribe and review the information in www.kccmultiplex.lk
              and purchase movie tickets and related products/services for your personal use.{' '}
            </li>
            <li>
              We reserve the right to modify or discontinue, temporarily or permanently, this site
              or any part of this site with or without notice. You agree that we shall not be liable
              to you or any third party for any modification, suspension or discontinuance of the
              site and / or any services under this agreement, for any reason. We do not guarantee
              continuous, uninterrupted or secure access to our service, and operation of our site
              which may be interfered with by numerous factors outside of our control. In addition,
              the site could be unavailable during certain periods of time while it is being updated
              and modified. During this time, the site will be temporarily unavailable.{' '}
            </li>
            <li>
              Children under the age of 16 may not purchase any Product on this Site. If you are
              under the age of 16 and would like to purchase a product on this site, please ask your
              parent or guardian for permission to assist you in this.{' '}
            </li>
            <li>
              Content on this site, such as graphics, logos and film clips, information, text,
              material, software or advertisements, (Content) is protected by Sri Lankan and
              international copyright and trademark law.{' '}
            </li>
            <li>
              Content on the site must not be modified, copied, reproduced, republished, framed,
              uploaded to a third party, posted, transmitted or distributed in any way except as
              expressly provided for on the site, or as expressly authorised in writing by KCC
              Multiplex or its affiliates. Strictly on the condition that you keep the content
              intact and in the same form as presented on the network, you may use the content for
              your personal and non-commercial use.{' '}
            </li>
            <li>
              The KCC Multiplex logo and name are trademarks, and may not be used as part of your
              business or in connection with any goods or services without the prior written consent
              of KCC Multiplex{' '}
            </li>
            <li>
              Your Personal Information and Privacy{' '}
              <ul>
                <li>
                  KCC Multiplex Privacy Policy (available HERE), as may be amended from time to time
                  and incorporated herein by reference, forms part of these Terms, and includes
                  important information about how we may collect, hold, retain, use and disclose
                  personal information about you gathered in the course of your use of this site or
                  purchase of any product from this site. By using this site, submitting content to
                  this site, or purchasing or using any Product from this site, you consent to KCC
                  Multiplex collecting, holding, retaining, using and disclosing your personal
                  information in accordance with these Terms and the Privacy Policy, including for
                  direct marketing purposes.{' '}
                </li>
              </ul>
            </li>
            <li>
              Payments{' '}
              <ul>
                <li>
                  All payments are subject to the terms and conditions of each bank and we have no
                  authority over any payments made through the bank payment gateway. Details of your
                  credit / debit card may be securely held by the bank which processes your
                  transaction.{' '}
                </li>
                <li>
                  All prices include Value Added Tax (VAT) and Nation Building Tax as applicable.{' '}
                </li>
              </ul>
            </li>
            <li>
              Links and Advertisements{' '}
              <ul>
                <li>
                  This site includes links to other websites (Linked Websites). Unless otherwise
                  stated at those websites, those websites are not controlled by KCC Multiplex. By
                  using those links, you acknowledge and agree:{' '}
                  <ul>
                    <li>
                      KCC Multiplex is not responsible for the availability of, or in relation to,
                      content located on or through a Linked Website; inclusion of a Linked Website
                      on this Site does not imply any endorsement of the Linked Website by KCC
                      Multiplex or its affiliates or their respective directors, officers or
                      employees; and you link to any Linked Website at your own risk.{' '}
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
          <h2>General Terms &amp; Conditions of Entry to KCC Multiplex </h2>
          <ul>
            <li>
              By entering the premises of KCC Multiplex, located at 5 Dalada Veediya, Kandy, you
              hereby accept and agree to comply with the below mentioned terms and conditions.{' '}
            </li>
            <li>
              Customers who are in possession of a valid ticket will only be permitted to enter the
              designated cinema for the specified duration of the show printed on the ticket.
            </li>
            <li>
              Customers who are disruptive, unwell, antisocial or violent will be asked to leave the
              premises immediately without any entitlement to a refund and KCC Multiplex Management
              reserves the right to determine what constitutes disruptive, unwell, antisocial or
              violent behavior.{' '}
            </li>
            <li>
              Mobile phones, cameras and all other electronic devices must be switched off or on
              silent mode before you enter any cinema.
            </li>
            <li>
              Photography and/or videography is/are strictly prohibited inside any cinema. You are
              not permitted to bring mobile phones, cameras and/or recording equipment of any kind
              into any cinema for the purposes of illegal activity. We reserve the right to carry
              out random bag checks and refuse equipment at the sole discretion of the KCC Multiplex
              Management.
            </li>
            <li>
              Smoking (including any form of electronic cigarette or other smoking devices) is not
              permitted anywhere in any part of the cinema or surrounding lobbies and public areas
              of the KCC Multiplex premises.
            </li>
            <li>
              You must keep your personal belongings with you at all times. We accept no
              responsibility for the loss, theft, alteration or damage to any personal items brought
              into the premises.{' '}
            </li>
            <li>
              You may not bring any dangerous and/or illegal items into any part of the cinema or
              surrounding lobbies and public areas of the KCC Multiplex premises at any time.{' '}
              <ul>
                <li>
                  Keep prams and strollers out of the way. While they can be taken into the cinema,
                  please don’t leave them in the aisles or exits. They may be positioned in
                  designated wheelchair areas, however please note wheelchair users have priority,
                  so staff may direct prams or strollers to be positioned elsewhere.{' '}
                </li>
              </ul>
            </li>
          </ul>
          <h2>Tickets </h2>
          <ul>
            <li>
              Ticket(s) can be purchased only at the Box Office counter (Level 2) or online through
              our website - www.kccmultiplex.lk{' '}
            </li>
            <li>All ticket prices are inclusive of government taxes.</li>
            <li>
              Purchased ticket(s) from the Box Office must be presented for validation at every
              Cinema entrance prior to every show.{' '}
            </li>
            <li>Online booking will be closed 1 hour prior to the listed showtime of a movie.</li>
            <li>
              The QR code received (via email) for ticket(s) purchased online can be presented on
              your smartphone at the Cinema entrance for validation, or,
            </li>
            <li>
              you can print ticket(s) purchased online at home and bring the printed copy which
              needs to be scanned at the cinema entrance for validation.{' '}
            </li>
            <li>
              Physical tickets can be obtained from the Box Office counter by presenting proof of
              purchase online with the reference number received via SMS/email.{' '}
            </li>
            <li>
              Lost, stolen or damaged tickets will not be replaced unless authenticated by a valid
              ticket reference number received via SMS/email.
            </li>
          </ul>
          <h2>Refunds &amp; Exchanges</h2>

          <ul>
            <li>
              We are under no obligation to exchange or refund tickets, purchased online or at the
              Box Office, once a booking has been confirmed. We are not responsible and cannot
              provide refunds or date and/or time changes in the event you select the wrong film, a
              different time, a film you cannot attend, a change of mind and/or any other personal
              reasons.{' '}
            </li>
            <li>
              Should a show become suspended due to a technical fault and/or any other problem
              originating within the control of the KCC Multiplex Management, tickets can be
              exchanged for another future show time and/or date. No refunds will be provided.
            </li>
          </ul>

          <h2>Age Restrictions </h2>

          <ul>
            <li>
              We thoroughly follow film classifications provided by National Film Corporation in Sri
              Lanka regarding the minimum age entry restrictions to shows. We may ask you to present
              proof of age at any point when entering the cinema and refuse the admission of anyone
              who is below the minimum age specified by the said classification.{' '}
            </li>
            <li>
              Minors must be accompanied at all times by an adult who is at least 18 years of age.{' '}
            </li>
          </ul>

          <h2>Food &amp; Drink</h2>

          <ul>
            <li>
              No food or beverage from outside is permitted at the cinema premises. Only items from
              Rancrisp (L2) and Snax (L2 & L4) are permitted.{' '}
            </li>
            <li>
              Only food &amp;/or drink brought at our concession stand (Level 4) can be brought in
              or consumed inside cinemas.{' '}
              <ul>
                <li>
                  Our popcorn may contain partially popped &amp; unpopped kernels. KCC Multiplex
                  accepts no responsibility for injury or damaged caused.{' '}
                </li>
              </ul>
            </li>
          </ul>

          <h2>Movie Showtimes &amp; Schedules </h2>

          <ul>
            <li>
              We will always try to screen shows in accordance with the schedule that we published.
              However, we reserve the right to cancel a show or change the timing, due to
              unavoidable reason(s). In case of such an incident we will issue another ticket for a
              show on an alternative occasion. No refunds will be provided.
            </li>
            <li>
              We are unable to take responsibility for movie schedules advertised by third parties.
              Official schedules are published on our website (
              <a href="https://kccmultiplex.lk">www.kccmultiplex.lk</a>) and available at the Box
              Office at 5, Dalada Veediya, Kandy.{' '}
            </li>
          </ul>

          <h2>CCTV Operation</h2>

          <ul>
            <li>
              Please note CCTV is in operation for the purposes of crime prevention and public
              safety.{' '}
            </li>
            <li>
              KCC Multiplex Management holds the right to claim and/or report, to local authorities,
              any theft or damages done to the property.
            </li>
            <li>
              KCC Multiplex Management holds the right to report, to authorities, any incidents of
              inflicted harm, theft or illegal behavior done to members of the public or staff.
            </li>
          </ul>

          {/* <h2>COVID-19 Safety at KCC Multiplex </h2>

          <ul>
            <li>
              As a condition of the booking process, guests are acknowledging that they will comply
              with prevailing local health orders during their time in cinema. KCC Multiplex has the
              right to refuse entry to guests who are not fully vaccinated against COVID-19, unless
              a lawful exemption applies. Guests who have booked tickets or food and beverage items
              and do not meet health and safety requirements will not be permitted to enter.{' '}
            </li>
          </ul> */}

          <h2>Our Rights – KCC Multiplex Management Reserve The Right To… </h2>

          <ul>
            <li>Refuse guests’ entry to the premises. </li>
            <li>
              Request guests leave the premises without a refund, should they breach any of these
              conditions of entry.{' '}
            </li>
            <li>
              Inspect any bag at any time on the premises. No alcohol, bottles, cans, aerosols,
              glass, outside food or beverages, laser pointers, large bags, personal stereos,
              electronic equipment, rollerblades, bicycles, scooters or skateboards are permitted,
              unless otherwise advised.{' '}
            </li>
          </ul>
        </ContentBlock>
      </TermsAndConditionsStyled>
    </Layout>
  );
}
